var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.375C0 3.74511 0.250223 3.14102 0.695621 2.69562C1.14102 2.25022 1.74511 2 2.375 2H16.625C17.2549 2 17.859 2.25022 18.3044 2.69562C18.7498 3.14102 19 3.74511 19 4.375V5.5625H0V4.375ZM0 7.9375V13.875C0 14.5049 0.250223 15.109 0.695621 15.5544C1.14102 15.9998 1.74511 16.25 2.375 16.25H16.625C17.2549 16.25 17.859 15.9998 18.3044 15.5544C18.7498 15.109 19 14.5049 19 13.875V7.9375H0ZM3.5625 10.3125H4.75C5.06494 10.3125 5.36699 10.4376 5.58969 10.6603C5.81239 10.883 5.9375 11.1851 5.9375 11.5V12.6875C5.9375 13.0024 5.81239 13.3045 5.58969 13.5272C5.36699 13.7499 5.06494 13.875 4.75 13.875H3.5625C3.24756 13.875 2.94551 13.7499 2.72281 13.5272C2.50011 13.3045 2.375 13.0024 2.375 12.6875V11.5C2.375 11.1851 2.50011 10.883 2.72281 10.6603C2.94551 10.4376 3.24756 10.3125 3.5625 10.3125Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.86249180a9a12899e18e84a14fc7262e.svg";
export { ForwardRef as ReactComponent };